import { createSlice } from '@reduxjs/toolkit'
import { HCPAuthState } from '../types/hcpAuth.types'
const initialState: HCPAuthState = {
  hcpAuthData: null,
}

const authSlice = createSlice({
  name: 'hcpAuth',
  initialState: initialState,
  reducers: {
    setHCPAuthUserData: (state: HCPAuthState, action) => {
      state.hcpAuthData = action?.payload
    },
    logoutHCPAuthUser: (state: HCPAuthState) => {
      state.hcpAuthData = null
    },
    getHCPAuthDataAction: () => {
      return
    },
    logoutHCPAuthAction: () => {
      return
    },
  },
})

export const { logoutHCPAuthUser, setHCPAuthUserData, getHCPAuthDataAction,logoutHCPAuthAction } =
  authSlice.actions
export default authSlice.reducer
